import api from '@/factories/api';

export default {
  namespaced: true,

  state: {
    folders: [],
    foldersLoaded: false,
    folderLoading: false,
  },

  mutations: {
    setFolders: (state, folders) => {
      state.folders = folders;
    },
    setFoldersLoaded: (state, loaded) => {
      state.foldersLoaded = loaded;
    },
    setFolderLoading: (state, loading) => {
      state.folderLoading = loading;
    },
  },

  getters: {
    getFolder(state) {
      const findFolder = (folders, folderId) => {
        for (const folder of folders) {
          if (folder.id === folderId) return folder;
          if (folder.folders?.length) {
            const found = findFolder(folder.folders, folderId);
            if (found) return found;
          }
        }
        return undefined;
      };
      return (folderId) => findFolder(state.folders, folderId);
    },
  },

  actions: {
    async loadFolders({ commit, state }) {
      if (state.foldersLoaded) return;

      try {
        const folders = await api().get('cg/files_folders?schema=full');
        commit('setFolders', folders);
      } finally {
        commit('setFoldersLoaded', true);
      }
    },

    async loadSingleFolder({ commit, getters, state }, folderId) {
      if (getters.getFolder(folderId)) return;

      try {
        const folder = await api().get(
          `cg/files_folders/${folderId}?schema=full`
        );
        commit('setFolders', [folder, ...state.folders]);
      } finally {
        commit('setFolderLoading', false);
      }
    },
  },
};
